// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

body {
  margin: 0;
  padding: 0;
}

.resume3 {
  width: 90%;
  max-width: 800px;
  margin: 80px auto;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}



.main3 {
  padding: 20px;
  padding-bottom: 0px;
}

.name3 {
  font-size: 1.8rem;
  font-weight: bold;
  text-align: center;
  color: rgb(40, 105, 138);
  margin-top: 0px;
  margin-bottom: 0px;
  text-transform: uppercase;
}

.job-title3 {
  text-align: center;
  /* font-size: 1rem; */
  color: #555;
  text-transform: capitalize;
}
.bold-title::first-letter {
  text-transform: uppercase !important;
}
.pt3 {
  /* Optional: capitalize each word */
  text-transform: capitalize;
}

.button-container3{
  width: 100%;
  display: flex;
  justify-content: space-between; /* Align buttons to opposite ends */
  align-items: center;
  margin: 10px 0; /* Add some spacing */
  padding: 0 0rem 0 15rem;
  }
.db3{
  margin-right: 15rem;
  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 39px;
  display: block; 
  margin-left: 6rem;
  text-wrap: nowrap;
}
.bk3{
  background-color:#474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 39px;
  display: block; 
  margin-left: -6rem;

}
@media (max-width: 768px) {
  .db3{
 
    margin-left: 0px;
    text-wrap: nowrap;
    margin-top: 0px;
  }
  .button-container3 {
    padding: 0px;
  }
  .bk3{
    margin-left: 0rem !important;
  }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    .db3{
      margin-left: 154px;
      text-wrap: nowrap;
      margin-top: 3rem;
    }
    .button-container3{
    
      margin-left: 0px;
      align-items: flex-start;
    }
    .bk3{
      margin-left: 0rem !important;
    }
  }
 

.contact-info,
.social-links {
  text-align: center;
  font-size: 0.9rem;
  color: #666;
  padding: 2px;
}

.icon {
  height: 16px;
  width: 16px;
  margin-right: 6px;
}

.section {
  /* margin-top: 20px; */
}

.section-header3 {
  background-color: rgb(73, 125, 151);
  color: #fff;
  padding: 4px;
  font-size: 1.1rem;
  font-weight: bold;
  margin-top: 2px;
  margin-bottom: 2px;
}

.section-content3 {
  padding: 2px 0;
  font-size: 14px !important;
  color: #333;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}
.pt3{
  font-size: 12px!important;
}
.bold-title {
  font-weight: bold;
}


.section-content3 p,
.section-content3 ul {
  margin: 1px 0;
  text-wrap: wrap;
    text-align: justify;
}

.hr3 {
  margin: 10px 0;
  border: none;
  border-bottom: 1px solid inherit;
}

.scroll-container3 {
  overflow-x: auto; 
  white-space: nowrap; 
  width: 100%; 
  max-width: 100vw;
}
.resume3{
  /* display: inline-block;  */
   width: 800px; /* Fixed width to maintain appearance */
  max-width: 800px; /* Prevents stretching */
  margin: 80px auto;

}

/* Responsive styling */
@media (max-width: 768px) {
  .download-btn {
      width: 100%;
  }

  .name3 {
    font-size: 1.8rem;
  }

  .job-title {
   font-size: 1rem;
  }
}
.addr{
  font-size: 14px;
  margin-bottom: 0px;
  text-align: center;
  text-wrap: wrap;
}


.footer3 {
  padding: 3px 0;
  margin-top: 20px;
  border-top: 1px solid #e9ecef; /* Top border for separation */

}

.footer-text3 {
  font-size: 16px;
  color: #6c757d; 
  text-align: end;
  margin-right: 15px;
  margin-bottom: 2px;
}

.footer-link3 {
  color: #007bff; /* Link color */
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/UseTemp3.css"],"names":[],"mappings":";;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,uCAAuC;AACzC;;;;AAIA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,0BAA0B;AAC5B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B,EAAE,mCAAmC;EACnE,mBAAmB;EACnB,cAAc,EAAE,qBAAqB;EACrC,uBAAuB;EACvB;AACF;EACE,mBAAmB;EACnB,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;;AAEpB;AACA;EACE;;IAEE,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,4BAA4B;EAC9B;EACA;EACA;IACE;MACE,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;IAClB;IACA;;MAEE,gBAAgB;MAChB,uBAAuB;IACzB;IACA;MACE,4BAA4B;IAC9B;EACF;;;AAGF;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,WAAW;EACX,gDAAgD;AAClD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,iBAAiB;AACnB;;;AAGA;;EAEE,aAAa;EACb,eAAe;IACb,mBAAmB;AACvB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,4BAA4B;GAC3B,YAAY,EAAE,uCAAuC;EACtD,gBAAgB,EAAE,wBAAwB;EAC1C,iBAAiB;;AAEnB;;AAEA,uBAAuB;AACvB;EACE;MACI,WAAW;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;GACC,eAAe;EAChB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,cAAc;EACd,gBAAgB;EAChB,6BAA6B,EAAE,8BAA8B;;AAE/D;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,qBAAqB;AACvB","sourcesContent":["\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n.resume3 {\r\n  width: 90%;\r\n  max-width: 800px;\r\n  margin: 80px auto;\r\n  background-color: #fff;\r\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n\r\n\r\n.main3 {\r\n  padding: 20px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.name3 {\r\n  font-size: 1.8rem;\r\n  font-weight: bold;\r\n  text-align: center;\r\n  color: rgb(40, 105, 138);\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.job-title3 {\r\n  text-align: center;\r\n  /* font-size: 1rem; */\r\n  color: #555;\r\n  text-transform: capitalize;\r\n}\r\n.bold-title::first-letter {\r\n  text-transform: uppercase !important;\r\n}\r\n.pt3 {\r\n  /* Optional: capitalize each word */\r\n  text-transform: capitalize;\r\n}\r\n\r\n.button-container3{\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: space-between; /* Align buttons to opposite ends */\r\n  align-items: center;\r\n  margin: 10px 0; /* Add some spacing */\r\n  padding: 0 0rem 0 15rem;\r\n  }\r\n.db3{\r\n  margin-right: 15rem;\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 39px;\r\n  display: block; \r\n  margin-left: 6rem;\r\n  text-wrap: nowrap;\r\n}\r\n.bk3{\r\n  background-color:#474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 39px;\r\n  display: block; \r\n  margin-left: -6rem;\r\n\r\n}\r\n@media (max-width: 768px) {\r\n  .db3{\r\n \r\n    margin-left: 0px;\r\n    text-wrap: nowrap;\r\n    margin-top: 0px;\r\n  }\r\n  .button-container3 {\r\n    padding: 0px;\r\n  }\r\n  .bk3{\r\n    margin-left: 0rem !important;\r\n  }\r\n  }\r\n  @media (min-width: 768px) and (max-width: 1024px) {\r\n    .db3{\r\n      margin-left: 154px;\r\n      text-wrap: nowrap;\r\n      margin-top: 3rem;\r\n    }\r\n    .button-container3{\r\n    \r\n      margin-left: 0px;\r\n      align-items: flex-start;\r\n    }\r\n    .bk3{\r\n      margin-left: 0rem !important;\r\n    }\r\n  }\r\n \r\n\r\n.contact-info,\r\n.social-links {\r\n  text-align: center;\r\n  font-size: 0.9rem;\r\n  color: #666;\r\n  padding: 2px;\r\n}\r\n\r\n.icon {\r\n  height: 16px;\r\n  width: 16px;\r\n  margin-right: 6px;\r\n}\r\n\r\n.section {\r\n  /* margin-top: 20px; */\r\n}\r\n\r\n.section-header3 {\r\n  background-color: rgb(73, 125, 151);\r\n  color: #fff;\r\n  padding: 4px;\r\n  font-size: 1.1rem;\r\n  font-weight: bold;\r\n  margin-top: 2px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.section-content3 {\r\n  padding: 2px 0;\r\n  font-size: 14px !important;\r\n  color: #333;\r\n  font-family: Verdana, Geneva, Tahoma, sans-serif;\r\n}\r\n.pt3{\r\n  font-size: 12px!important;\r\n}\r\n.bold-title {\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n.section-content3 p,\r\n.section-content3 ul {\r\n  margin: 1px 0;\r\n  text-wrap: wrap;\r\n    text-align: justify;\r\n}\r\n\r\n.hr3 {\r\n  margin: 10px 0;\r\n  border: none;\r\n  border-bottom: 1px solid inherit;\r\n}\r\n\r\n.scroll-container3 {\r\n  overflow-x: auto; \r\n  white-space: nowrap; \r\n  width: 100%; \r\n  max-width: 100vw;\r\n}\r\n.resume3{\r\n  /* display: inline-block;  */\r\n   width: 800px; /* Fixed width to maintain appearance */\r\n  max-width: 800px; /* Prevents stretching */\r\n  margin: 80px auto;\r\n\r\n}\r\n\r\n/* Responsive styling */\r\n@media (max-width: 768px) {\r\n  .download-btn {\r\n      width: 100%;\r\n  }\r\n\r\n  .name3 {\r\n    font-size: 1.8rem;\r\n  }\r\n\r\n  .job-title {\r\n   font-size: 1rem;\r\n  }\r\n}\r\n.addr{\r\n  font-size: 14px;\r\n  margin-bottom: 0px;\r\n  text-align: center;\r\n  text-wrap: wrap;\r\n}\r\n\r\n\r\n.footer3 {\r\n  padding: 3px 0;\r\n  margin-top: 20px;\r\n  border-top: 1px solid #e9ecef; /* Top border for separation */\r\n\r\n}\r\n\r\n.footer-text3 {\r\n  font-size: 16px;\r\n  color: #6c757d; \r\n  text-align: end;\r\n  margin-right: 15px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.footer-link3 {\r\n  color: #007bff; /* Link color */\r\n  text-decoration: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
